<template>
  <el-form>
    <el-table :data="preposts" stripe ref="tablePrepost">
      <el-table-column v-if="orderStatus === '1'" type="selection" width="60" />
      <el-table-column sortable prop="tag" label="Objeto" />
      <el-table-column sortable prop="services.servicegroup.name" label="Serviço" />
      <el-table-column sortable prop="destinyzipcode" label="CEP Destino" />
      <el-table-column sortable prop="destinyname" label="Destinatário" />
      <el-table-column sortable prop="created_at" :label="'Data da prepostagem'">
        <template slot-scope="scope">
          {{ scope.row.createdAt | dateFormater }}
        </template>
      </el-table-column>
    </el-table>
    <el-form-item v-if="orderStatus === '1'" style="text-align: right; margin-top: 15px;">
      <el-button type="warning" autofocus @click="removeObjects()">REMOVER OBJETOS DA OS</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { OrderServicesService } from "@/services/customers/order.services.services";
import moment from 'moment';

export default {
  name: 'OrderObjects',
  props: {
    preposts: Array,
    os_id: Number,
    orderStatus: String
  },
  methods: {
    removeObjects() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      const data = {
        order_service_id: vm.os_id,
        preposts: vm.$refs.tablePrepost.selection,
        actionType: 'REMOVE'
      };

      OrderServicesService
        .updateObjects(data)
        .then(response => {
          this.$emit('historyChange');
          this.$emit('osChange');
          this.$message({
            type: "success",
            message: "Ordem de Serviço atualizada com sucesso!",
          });
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  },
  filters: {
    dateFormater(date) {
      if (date) {
        return moment.utc(date).utcOffset('+03:00').format('DD/MM/YYYY');
      }
    },
  },
}
</script>